import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { ClickAwayListener, Box, Popper } from "@mui/material";
import { useState, useRef, useCallback, useEffect } from "react";
import { DatePicker } from "../components/DatePicker/DatePicker.js";
import { DATA_TEST_ID_INHERITED } from "../../../constants/DATA_TEST_ID_INHERITED.js";
import { pickerModifiers } from "../popperModifiers.js";
import { inheritDataTestId } from "../../../utils/dataTestId.js";
const DatePickerPopup = ({
  children,
  onChange,
  disabled,
  onOpen,
  sx,
  open,
  ...props
}) => {
  const [el, setElement] = useState(null), isOpen = !!el, containerRef = useRef(null), handleToggle = (el2) => {
    el2 ? (onOpen == null || onOpen(!0), setElement(el2)) : isOpen && (onOpen == null || onOpen(!1), setElement(null));
  }, handleToggleRef = useRef(handleToggle);
  handleToggleRef.current = handleToggle;
  const handleContainerClick = (e) => {
    !el && !disabled && handleToggleRef.current(e.currentTarget);
  }, handleOnSelectValue = useCallback(
    (e) => {
      onChange == null || onChange(e), setTimeout(() => {
        handleToggleRef.current();
      }, 200);
    },
    [onChange]
  );
  return useEffect(() => {
    open && containerRef.current && !el && !disabled && handleToggleRef.current(containerRef.current);
  }, [disabled, el, open]), /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    ClickAwayListener,
    {
      onClickAway: () => {
        handleToggle();
      },
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          "data-test-id": inheritDataTestId(props, "date-picker-popup-container"),
          className: "click-away-container",
          onClick: handleContainerClick,
          ref: containerRef,
          sx: {
            width: sx == null ? void 0 : sx.width,
            maxWidth: sx == null ? void 0 : sx.maxWidth,
            minWidth: sx == null ? void 0 : sx.minWidth
          },
          children: [
            /* @__PURE__ */ jsx(
              Popper,
              {
                open: isOpen,
                anchorEl: el,
                placement: "bottom-start",
                modifiers: pickerModifiers,
                children: /* @__PURE__ */ jsx(
                  DatePicker,
                  {
                    "data-test-id": DATA_TEST_ID_INHERITED,
                    ...props,
                    onChange: handleOnSelectValue
                  }
                )
              }
            ),
            children()
          ]
        }
      )
    }
  ) });
};
export {
  DatePickerPopup
};
//# sourceMappingURL=DatePickerPopup.js.map
